<script>
    import { Moon } from "svelte-loading-spinners";

    export let handleClick;
    export let content = "";
    export let promise;
    export let buttonClass = "bg-lightBlue-200";
    export let size = "20";
    export let moonColors = ["#89CFF0", "white"]
    export let icon = null;

    let isHover = false;

    $: baseClass = icon
        ? "w-10 h-10 text-sm border inline-flex items-center justify-center rounded-full cursor-pointer outline-none focus:outline-none duration-150"
        : "border-0 bg-li p-2 px-4 font-semibold text-white hover:shadow-lg w-44 flex justify-center items-center outline-none focus:outline-none duration-150";
</script>

<button
	class="{baseClass} {buttonClass}"
	on:click|preventDefault={handleClick}
    on:mouseover|preventDefault={() => isHover = true}
    on:mouseleave|preventDefault={() => isHover = false}
>
	{#await promise}
		<Moon size="{size}" color="{ isHover ? moonColors[0] : moonColors[1] }" />
	{:then v}
		{#if icon}
			<i class="fa {icon}"></i>
		{:else}
			{content}
		{/if}
    {:catch _e}
		<Moon size="{size}" color="{ isHover ? moonColors[0] : moonColors[1] }" />
	{/await}
</button>
